import { all } from "redux-saga/effects";
import * as dashboardActions from "./dashboard/sagas";
import * as invoiceActions from "./invoice/sagas";
import * as createEditStatementActions from "./createEditStatement/sagas";
import * as invoiceListActions from "./invoiceList/sagas";
import * as agentSagas from "./agent/sagas";
import * as appSagas from "./app/sagas";
import * as prepaymentSagas from "./prepayment/sagas";

export default function* rootSaga() {
  yield all([
    dashboardActions.watchFetchingDashboardDataAsync(),
    dashboardActions.watchFetchingInvoiceTypesAsync(),
    invoiceActions.watchFetchInvoiceAsync(),
    invoiceActions.watchGoToPaymentGatewayAsync(),
    invoiceActions.watchDownloadInvoiceAsync(),
    invoiceActions.watchDeactivateStatementAsync(),
    invoiceActions.watchPrintPaymentAsync(),
    invoiceActions.watchRefreshWebHooksAsync(),
    invoiceListActions.watchDownloadInvoiceListAsync(),
    invoiceListActions.watchFetchInvoiceListAsync(),
    invoiceActions.watchCheckWebHooksAsync(),
    invoiceActions.watchCheckVoidAvailableAsync(),
    invoiceActions.watchVoidInvoiceAsync(),
    invoiceActions.watchChangeInvoiceStatusAsync(),
    createEditStatementActions.watchCreateEditStatementAsync(),
    createEditStatementActions.watchFetchInvoiceListAsync(),
    createEditStatementActions.watchFetchingNameAsync(),
    createEditStatementActions.watchFetchingStatementAsync(),
    agentSagas.watchFetchAgentAsync(),
    agentSagas.watchSearchAgentAsync(),
    agentSagas.watchAddAgentAsync(),
    agentSagas.watchDeleteAgentAsync(),
    appSagas.watchFetchingUserAsync(),
    prepaymentSagas.watchCreatePrePaymentAsync()
  ]);
}
